module.exports = __webpack_public_path__ + "salesforce-2-9ab36a25581a84832386172eca5a375b.webp";